'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ngRedux = require('ng-redux');

var _ngRedux2 = _interopRequireDefault(_ngRedux);

var _getPurchasedProducts = require('ifeis-isomorphic/lib/redux/actions/products/getPurchasedProducts');

var purchasedProducts = _interopRequireWildcard(_getPurchasedProducts);

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductQuantityController = function () {
  function ProductQuantityController(feis, $ngRedux, fRouterHistoryService, msgService, fCSVReportsService) {
    var _this = this;

    _classCallCheck(this, ProductQuantityController);

    this.purchasedProducts = {};

    this.fRouterHistoryService = fRouterHistoryService;
    this.$ngRedux = $ngRedux;
    this.msgService = msgService;
    this.fCSVReportsService = fCSVReportsService;
    this.headers = ['Product', 'Description', 'Quantity'];
    this.isLoading = true;
    this.feis = feis;
    $ngRedux.dispatch(purchasedProducts.getPurchasedProducts(feis.id)).then(function (purchasedProducts) {
      var productName = [];
      var productsArray = purchasedProducts.payload.reduce(function (accum, payloadProduct) {
        payloadProduct.productsArray.forEach(function (product) {
          if (!productName.includes('' + payloadProduct.accountId + product.id)) {
            accum.push(product);
            productName.push('' + payloadProduct.accountId + product.id);
          }
          return accum;
        });
        return accum;
      }, []);

      _this.purchasedProducts = productsArray.reduce(function (accum, product) {
        if (accum[product.name] && product.name !== "") {
          var descriptionWithPurchased = accum[product.name].descriptions || {};
          var descriptions = Object.keys(descriptionWithPurchased) || [];
          if (descriptions.includes(product.description)) {
            descriptionWithPurchased[product.description] = descriptionWithPurchased[product.description] + product.purchased;
          } else {
            descriptionWithPurchased[product.description] = product.purchased;
          }
          delete accum[product.name].descriptions;
          accum[product.name].descriptions = descriptionWithPurchased;
          accum[product.name].totalPurchased = accum[product.name].totalPurchased + product.purchased;
        } else {
          accum[product.name] = {
            totalPurchased: product.purchased,
            descriptions: _defineProperty({}, product.description, product.purchased)
          };
        }
        return accum;
      }, {});
    }).catch(function (error) {
      return _this.msgService.displayErrorMsg(error.message || error.toString());
    }).finally(function () {
      return _this.isLoading = false;
    });
  }

  _createClass(ProductQuantityController, [{
    key: 'back',
    value: function back() {
      this.fRouterHistoryService.back();
    }
  }, {
    key: 'generateExcelReport',
    value: function generateExcelReport() {
      var _this2 = this;

      var csv = [];
      csv.push(this.headers);
      Object.keys(this.purchasedProducts).forEach(function (productName) {
        csv.push([productName, '', (_this2.purchasedProducts[productName] || {}).totalPurchased]);
        var descriptions = (_this2.purchasedProducts[productName] || {}).descriptions;
        Object.keys(descriptions).forEach(function (description) {
          return csv.push(['', description, _this2.purchasedProducts[productName]['descriptions'][description]]);
        });
      });

      this.fCSVReportsService.prepareCSV(csv, this.feis.slug + '_Quantity_by_product.csv');
    }
  }]);

  return ProductQuantityController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.reports.quantity-by-product', []).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.reports.quantity-by-product', {
    url: '/quanitity-by-product',
    template: require('./tpl.html'),
    controller: ProductQuantityController,
    controllerAs: 'ctrl'
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/reports/quantity-by-product/index.js
// module id = 566
// module chunks = 0